import { render, staticRenderFns } from "./cooperateInfo.vue?vue&type=template&id=562b277a&scoped=true"
import script from "./cooperateInfo.vue?vue&type=script&lang=js"
export * from "./cooperateInfo.vue?vue&type=script&lang=js"
import style0 from "./cooperateInfo.vue?vue&type=style&index=0&id=562b277a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562b277a",
  null
  
)

export default component.exports